import styled from 'styled-components';
import { Text } from './Text';

export const Heading = styled(Text).attrs((props) => ({
  size: props.size || 'lg',
  bold: true,
  capital: true,
  mb: props.mb || '10px',
}))``;
